export default "__VITE_ASSET__3f_FVWUp__"